/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { LicenseBundle } from './LicenseBundle';
import {
    LicenseBundleFromJSON,
    LicenseBundleFromJSONTyped,
    LicenseBundleToJSON,
} from './LicenseBundle';
import type { LicensePlanType } from './LicensePlanType';
import {
    LicensePlanTypeFromJSON,
    LicensePlanTypeFromJSONTyped,
    LicensePlanTypeToJSON,
} from './LicensePlanType';

/**
 * 
 * @export
 * @interface TenantLicensePlanDto
 */
export interface TenantLicensePlanDto {
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    licenseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    ipin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    companyId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    customerProvidedOptionalSiteName?: string | null;
    /**
     * 
     * @type {LicenseBundle}
     * @memberof TenantLicensePlanDto
     */
    bundle?: LicenseBundle;
    /**
     * 
     * @type {LicensePlanType}
     * @memberof TenantLicensePlanDto
     */
    planType?: LicensePlanType;
    /**
     * 
     * @type {number}
     * @memberof TenantLicensePlanDto
     */
    workPointPackage?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    expirationDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    issuedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    creationTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantLicensePlanDto
     */
    ptwTrial?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    ptwTrialType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TenantLicensePlanDto
     */
    readonly daysLeft?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantLicensePlanDto
     */
    readonly isValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantLicensePlanDto
     */
    $type?: TenantLicensePlanDtoTypeEnum;
}


/**
 * @export
 */
export const TenantLicensePlanDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedLicenseComponentDtoTenantLicensePlanDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.LicenseComponent.Dto.TenantLicensePlanDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TenantLicensePlanDtoTypeEnum = typeof TenantLicensePlanDtoTypeEnum[keyof typeof TenantLicensePlanDtoTypeEnum];



/**
 * Check if a given object implements the TenantLicensePlanDto interface.
 */
export function instanceOfTenantLicensePlanDto(value?: unknown): value is TenantLicensePlanDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TenantLicensePlanDtoTypeEnum)[0];
}

export function TenantLicensePlanDtoFromJSON(json: any): TenantLicensePlanDto {
    return TenantLicensePlanDtoFromJSONTyped(json, false);
}

export function TenantLicensePlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantLicensePlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'licenseId': json['licenseId'] == null ? undefined : json['licenseId'],
        'ipin': json['ipin'] == null ? undefined : json['ipin'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'customerProvidedOptionalSiteName': json['customerProvidedOptionalSiteName'] == null ? undefined : json['customerProvidedOptionalSiteName'],
        'bundle': json['bundle'] == null ? undefined : LicenseBundleFromJSON(json['bundle']),
        'planType': json['planType'] == null ? undefined : LicensePlanTypeFromJSON(json['planType']),
        'workPointPackage': json['workPointPackage'] == null ? undefined : json['workPointPackage'],
        'expirationDate': json['expirationDate'] == null ? undefined : json['expirationDate'],
        'issuedDate': json['issuedDate'] == null ? undefined : json['issuedDate'],
        'deliveryDate': json['deliveryDate'] == null ? undefined : json['deliveryDate'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'ptwTrial': json['ptwTrial'] == null ? undefined : json['ptwTrial'],
        'ptwTrialType': json['ptwTrialType'] == null ? undefined : json['ptwTrialType'],
        'daysLeft': json['daysLeft'] == null ? undefined : json['daysLeft'],
        'isValid': json['isValid'] == null ? undefined : json['isValid'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TenantLicensePlanDtoToJSON(value?: Omit<TenantLicensePlanDto, 'daysLeft'|'isValid'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'licenseId': value['licenseId'],
        'ipin': value['ipin'],
        'companyId': value['companyId'],
        'customerProvidedOptionalSiteName': value['customerProvidedOptionalSiteName'],
        'bundle': LicenseBundleToJSON(value['bundle']),
        'planType': LicensePlanTypeToJSON(value['planType']),
        'workPointPackage': value['workPointPackage'],
        'expirationDate': value['expirationDate'],
        'issuedDate': value['issuedDate'],
        'deliveryDate': value['deliveryDate'],
        'creationTime': value['creationTime'],
        'ptwTrial': value['ptwTrial'],
        'ptwTrialType': value['ptwTrialType'],
        '$type': value['$type'],
    });
}

